const token = () => document.querySelector('meta[name="csrf-token"]').content;

const defaultOptions = {
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-Token': token(),
  },
  credentials: 'include',
};

const appendFormData = (formData, key, value) => {
  if (value === null || value === undefined) {
    return;
  }

  if (value instanceof Blob) {
    formData.append(key, value);
  } else if (Array.isArray(value)) {
    value.forEach((item) => appendFormData(formData, `${key}[]`, item));
  } else if (typeof value === 'object') {
    Object.keys(value).forEach((k) => appendFormData(formData, `${key}[${k}]`, value[k]));
  } else {
    formData.append(key, value);
  }
};

const wrapper = async (
  method,
  {
    image, attachments, formData, payload = {}, name, url, keepalive = false, catch: catchCallback,
  },
) => {
  try {
    const options = {
      ...defaultOptions,
      method,
      headers: { ...defaultOptions.headers },
      keepalive,
    };

    if (method !== 'GET') {
      if (formData) {
        options.body = formData;
        delete options.headers['Content-Type'];
      } else if (image) {
        const imageData = new FormData();
        imageData.append('image', image, name);

        options.body = imageData;
        delete options.headers['Content-Type'];
      } else if (attachments && attachments.length > 0) {
        const attachmentData = new FormData();

        for (let i = 0; i < attachments.length; i += 1) {
          attachmentData.append('browse_file[]', attachments[i]);
        }

        Object.keys(payload).forEach((key) => appendFormData(attachmentData, key, payload[key]));

        options.body = attachmentData;
        delete options.headers['Content-Type'];
      } else {
        options.body = JSON.stringify(payload);
      }
    }
    const request = await fetch(url, options);
    const response = await request.json();

    return response;
  } catch (error) {
    if (catchCallback) {
      catchCallback(error);
    }
    console.warn(error) // eslint-disable-line
    return { serverErrors: error };
  }
};

const Fetch = {
  get: wrapper.bind(null, 'GET'),
  post: wrapper.bind(null, 'POST'),
};

export default Fetch;
